import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=defa315e&"
import script from "./claim.vue?vue&type=script&lang=ts&"
export * from "./claim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports